module.exports = __webpack_public_path__ + "static/logo-dark-dde43e64f9d6d80bd3b3cf4d72351a8c.svg";